import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";
import React, { ReactElement } from "react";

interface DataCardProps {
    icon?: React.ReactNode;
    title: string;
    description?: string;
    children: React.ReactNode;
    className?: string;
    contentClassName?: string;
}

export const DataCard = ({
    icon,
    title,
    description,
    children,
    className,
    contentClassName,
}: DataCardProps) => {
    return (
        <Card className={className}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">{title}</CardTitle>
                {icon && React.isValidElement(icon) &&
                    React.cloneElement(icon as ReactElement<{ className?: string }>, {
                        className: "h-4 w-4 text-muted-foreground",
                    })}
            </CardHeader>
            {description && (
                <CardDescription className="px-6">{description}</CardDescription>
            )}
            <CardContent className={cn("space-y-4", contentClassName)}>
                {children}
            </CardContent>
        </Card>
    );
}; 